import { LOGIN_FLOW_KEY, getStorageItem } from "../storage";
import { useLocalStorage } from "./useStorage";

export type LoginFlow = "cx" | null;

export const useLoginFlow = () => {
  const [loginFlow, setLoginFlow] = useLocalStorage<LoginFlow>(
    LOGIN_FLOW_KEY,
    null
  );
  return { loginFlow, setLoginFlow };
};

export const getLoginFlow = (): LoginFlow =>
  getStorageItem<LoginFlow>(LOGIN_FLOW_KEY) ?? null;
